"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1274],{

/***/ 7171:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M0": function() { return /* binding */ LandingWhiteSec; },
/* harmony export */   "kC": function() { return /* binding */ Flex; },
/* harmony export */   "kj": function() { return /* binding */ LandingGreySecWrap; },
/* harmony export */   "zq": function() { return /* binding */ LandingGreySec; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5505);

var Flex = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "shared-styled-components__Flex",
  componentId: "sc-1i94ptm-0"
})(["display:flex;align-items:center;"]);
var LandingGreySec = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "shared-styled-components__LandingGreySec",
  componentId: "sc-1i94ptm-1"
})(["background:#f5f5f5;padding:", ";margin-top:-120px;margin-bottom:", ";@media only screen and (max-width:768px){padding:", ";margin-top:", ";}"], function (props) {
  return props.padding;
}, function (props) {
  return props.marginBottom;
}, function (props) {
  return props.padding || "16px";
}, function (props) {
  return props.marginTop || "0px";
});
var LandingGreySecWrap = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "shared-styled-components__LandingGreySecWrap",
  componentId: "sc-1i94ptm-2"
})(["width:1200px;margin:0 auto;background:#f5f5f5;@media only screen and (max-width:768px){width:100%;}"]);
var LandingWhiteSec = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "shared-styled-components__LandingWhiteSec",
  componentId: "sc-1i94ptm-3"
})(["width:1200px;margin:0 auto;background:#fff;padding:", ";@media only screen and (max-width:768px){width:100%;padding:16px;}"], function (props) {
  return props.padding;
});

/***/ }),

/***/ 4809:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ LandingFaq_LandingFaq; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/shared-styled-components/index.ts
var shared_styled_components = __webpack_require__(7171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/LandingFaq/LandingFaq.style.ts

var LandingFaq_style_LandingFaq = styled_components_browser_esm["default"].section.withConfig({
  displayName: "LandingFaqstyle__LandingFaq",
  componentId: "sc-1cxnok3-0"
})(["display:flex;background:#fff;flex-direction:column;", ""], function (props) {
  return props.customFaq && "";
});
var LandingFaqTitle = styled_components_browser_esm["default"].h3.withConfig({
  displayName: "LandingFaqstyle__LandingFaqTitle",
  componentId: "sc-1cxnok3-1"
})(["font-family:\"Raleway\";font-weight:400;font-size:56px;line-height:72px;margin-bottom:40px;color:#000000;width:990px;"]);
var LandingFaqBody = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LandingFaqstyle__LandingFaqBody",
  componentId: "sc-1cxnok3-2"
})(["padding:0 24px 24px;"]);
var LandingFaqListItem = styled_components_browser_esm["default"].li.withConfig({
  displayName: "LandingFaqstyle__LandingFaqListItem",
  componentId: "sc-1cxnok3-3"
})(["margin-bottom:16px;position:relative;cursor:pointer;h5{padding:24px;}&::after{content:\"\";position:absolute;border:solid black;border-width:0 3px 3px 0;display:inline-block;padding:3px;right:24px;top:33px;transition:0.3s ease-in;}&.close:after{transform:rotate(45deg);-webkit-transform:rotate(45deg);}&.open:after{transform:rotate(-135deg);-webkit-transform:rotate(-135deg);}&:hover{background:#ffffff;box-shadow:0px 4px 16px rgba(0,0,0,0.16);border-radius:6px;}&:last-child{margin-bottom:unset;}"]);
var LandingFaqList = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "LandingFaqstyle__LandingFaqList",
  componentId: "sc-1cxnok3-4"
})(["width:1000px;gap:16px;"]);
var LandingFaqQues = styled_components_browser_esm["default"].h5.withConfig({
  displayName: "LandingFaqstyle__LandingFaqQues",
  componentId: "sc-1cxnok3-5"
})(["font-weight:700;font-size:22px;line-height:30px;color:#000;", ""], function (props) {
  return props.customFaq && "\nfont-family: 'Open Sans';\nfont-size: 12px;\nline-height: 16px;\ncolor: #000000;";
});
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/markdown/index.tsx + 1 modules
var markdown = __webpack_require__(8741);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/LandingFaq/LandingFaq.tsx







var LandingFaq = function LandingFaq(_ref) {
  var title = _ref.title,
      data = _ref.data;

  var _useState = (0,react.useState)(-1),
      exp = _useState[0],
      setExp = _useState[1];

  var handleClick = function handleClick(index) {
    exp != index ? setExp(index) : setExp(-1);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(shared_styled_components/* LandingWhiteSec */.M0, {
    id: "landing_faq_section",
    padding: "137px 0 84px 0",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingFaq_style_LandingFaq, {
      children: [title && /*#__PURE__*/(0,jsx_runtime.jsx)(LandingFaqTitle, {
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingFaqList, {
        children: data === null || data === void 0 ? void 0 : data.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingFaqListItem, {
            className: "".concat(exp == index ? "open" : "close"),
            onClick: function onClick() {
              return handleClick(index);
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LandingFaqQues, {
              children: item.ques
            }), exp === index && item.info && /*#__PURE__*/(0,jsx_runtime.jsx)(LandingFaqBody, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(markdown/* PlainMarkdown */.Y, {
                children: item.info
              })
            })]
          }, index);
        })
      })]
    })
  });
};

/* harmony default export */ var LandingFaq_LandingFaq = (LandingFaq);

/***/ }),

/***/ 8741:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* binding */ Markdown; },
  "Y": function() { return /* binding */ PlainMarkdown; }
});

// EXTERNAL MODULE: ../../node_modules/react-markdown/lib/react-markdown.js + 137 modules
var react_markdown = __webpack_require__(843);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/markdown/styled.ts

var StyledMarkdown = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__StyledMarkdown",
  componentId: "sc-61ko64-0"
})(["line-height:1.4;margin-top:15px;p,ol{margin:1em 0;&:last-child{margin-bottom:0;}&:first-child{margin-top:0;}}li{margin:0.5em 0;}"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/markdown/index.tsx



var Markdown = function Markdown(_ref) {
  var children = _ref.children,
      _ref$resetStyles = _ref.resetStyles,
      resetStyles = _ref$resetStyles === void 0 ? false : _ref$resetStyles;
  var content = children ? /*#__PURE__*/(0,jsx_runtime.jsx)(react_markdown/* ReactMarkdown */.D, {
    children: children
  }) : null;
  return resetStyles ? /*#__PURE__*/(0,jsx_runtime.jsx)(StyledMarkdown, {
    children: content
  }) : content;
};
var PlainMarkdown = function PlainMarkdown(_ref2) {
  var children = _ref2.children,
      _ref2$resetStyles = _ref2.resetStyles,
      resetStyles = _ref2$resetStyles === void 0 ? true : _ref2$resetStyles;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Markdown, {
    resetStyles: resetStyles,
    children: children
  });
};

/***/ })

}]);